import { render } from "./FooterOption.vue?vue&type=template&id=570dedef&scoped=true"
import script from "./FooterOption.vue?vue&type=script&lang=js"
export * from "./FooterOption.vue?vue&type=script&lang=js"

import "./FooterOption.vue?vue&type=style&index=0&id=570dedef&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570dedef"]])

export default __exports__